import { useEffect } from "react";
import { userState } from "../../interface/MainInterface";
import { HttpUnAuthApi } from "../../interface/unauth-api";

import { appConfig } from "../../config/Config";
import { AES, enc } from "crypto-js";

interface propsType {
    userState: userState;
}

const unAuthAPI = new HttpUnAuthApi();

const HartLogIn = (props: propsType) => {
  const stateInfo: URLSearchParams = new URLSearchParams(
    window.location.search
  );

  useEffect(() => {
    if (stateInfo.get("requestKey") && stateInfo.get("time")) {
      const keyInfo: string = stateInfo.get("requestKey") as string;
      const time: string = stateInfo.get("time") as string;
      const customKey = getUserKey(keyInfo);

      let date = new Date();
      let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
      let days = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let today = `${date.getFullYear()}${month}${days}` + "";
      
      if (time === today) {
        check_user(customKey);
      } else {
        console.log("로그인 실패");
      }
    }
  }, []);

  const getUserKey = (encryptedKey: string) => {
    const before = "1928374651973";
    const after = "1428385651973";
    const result = encryptedKey.replace(before, "").replace(after, "");
    return result;
  };

  const check_user = async (key_id: string) => {
    const param: any = {
      command: "get_hart_user_info",
      user_id: key_id,
    };
    const res = await unAuthAPI.post(param);
    if ("" + res.code == "200") {
      fnUserCount(key_id);
      procSession(res.response.user_info);
    } else {
      console.log("사용자 확인 실패");
      window.location.href = "/signin";
    }
  };

  const fnUserCount = async (userId: string) => {
    const param: any = {
      command: "update_user_count",
      user_id: userId,
    };

    const res = await unAuthAPI.post(param);
    if (res.code === "200") {
    }
  };

  const procSession = (sessionData: any) => {
    const sessionObj: any = {
      id: sessionData.sk,
      isAdmin: sessionData.is_admin,
      isSuperAdmin: sessionData.is_super_admin,
      name: sessionData.name,
      userInfo1: sessionData.user_info1,
      userInfo2: sessionData.user_info2,
      userInfo3: sessionData.user_info3,
      userInfo4: sessionData.user_info4,
      expire: Date.now() + 1000 * 60 * 60 * 24, // 24시간
    };
    console.log("session 저장");
    const objString = JSON.stringify(sessionObj);
    const encObjString = AES.encrypt(objString, appConfig.seed).toString();
    window.localStorage.setItem(appConfig.sessionName, encObjString);

    window.location.href = "/";
  }

  return (
    <></>
  )
}

export default HartLogIn;
